import styles from './PlanSelect.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextV2 } from 'src/components/TextV2/TextV2';
import { Installments, Plan } from '../types';

interface PlanSelectProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  plan: Plan;
}

export const PlanSelect: React.FC<PlanSelectProps> = ({ id, plan, ...props }) => {
  const { t } = useTranslation();

  let text;

  switch (plan.term) {
    case (Installments.P):
      text = t('order-summary.one-month-installment-title');
      break;
    case (Installments.IP3):
      text = t('order-summary.three-month-installment-title');
      break;
  }

  return (
    <label data-test="label" id={id}>
      <input type="radio" value={plan.term} name="plan-select" className={styles.input} {...props} />

      <h5 className={styles.text}>
        <TextV2 tagName="span" variant="body" value={text} data-test="text" />

        <TextV2 tagName="span" variant="body" value={t('order-summary.price', { price: plan.price })} data-test="price" />
      </h5>
    </label>
  );
};

PlanSelect.displayName = 'PlanSelect';
